export default __webpack_public_path__ + "static/screengroup-faae518875630b98b61f4954fe4ff2de.png";